import "./TabelaEmprestimoAluno.css";
import { useEffect, useState } from "react";
import { emprestimoAluno } from "../services/api";
import { ToastContainer } from "react-toastify";
import Tabela from "../tabelas/Tabela";
import lupa from "../imagem/lupa.svg";
import iconOlhoAberto from "../imagem/iconVisualizar.svg";
import ModalInfoLivro from "../modais/ModalInfoLivro";

export default function TabelaEmprestimoAluno() {
  const [dadosEmprestimo, setDadosEmprestimo] = useState([]);
  const [dadosFormatadosEmprestimo, setDadosFormatadosEmprestimo] = useState([]);

  const [carregandoPagina, setCarregandoPagina] = useState(false);

  const [inputFiltro, setInputFiltro] = useState("");

  const [totalPaginas, setTotalPaginas] = useState()
  const [paginandoEmprestimo, setPaginandoEmprestimo] = useState(0);

  const [modalVisualizarLivro, setModalVisualizarLivro] = useState(false);

  const [objLivro, setObjLivro] = useState();

  const colunasTabelaEmprestimoAluno = [
    "titulo",
    "emprestimo",
    "status",
    "devolucao",
    "acoes",
  ];

  const estiloTabelaEmprestimoAluno = {
    height: "130%",
    width: "100%",
    margin: "0 auto",
    border: "1px solid var(--cor-cinzaMargin)",
    borderRadius: 2,
  };

  useEffect(() => {
    carregarDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    formataDadosEmprestimo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dadosEmprestimo]);

  useEffect(() => {
    if (inputFiltro === "") {
      carregarDados();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputFiltro]);

  async function carregarDados(pagina = 1, limite = 10) {
    try {
      setCarregandoPagina(true);
      const objEmprestimoAluno = {
        limite: limite,
        pagina: pagina,
        nome: inputFiltro,
      };
      const { data } = await emprestimoAluno(objEmprestimoAluno);
      setDadosEmprestimo(data.content || []); // mudou emprestimo por content
      setPaginandoEmprestimo(data.totalPages || 0);
      setTotalPaginas(data.totalPages)
    } catch (error) {
    } finally {
      setCarregandoPagina(false);
    }
  }

  function formataDadosEmprestimo() {
    const objRetorno = [];
    dadosEmprestimo?.map((c) =>
      objRetorno.push({
        id: c.idLivro,

        titulo:
          c.titulo.length > 32 ? c?.titulo.slice(0, 32) + "..." : c?.titulo,

        autor: c?.autor,

        anoPublicacao: c?.anoPublicacao,

        genero: c?.genero,

        quantidadeLivros: c?.livrosDisponiveis,

        sinopse: c?.sinopse,

        emprestimo: c?.dataEmprestimo,

        status: c.status === "EM_DIA" ? "Em dia" : "Em atraso",

        devolucao: c?.dataDevolucao,

        quantidadeAvaliacoes: c.quantidadeAvaliacoes,

        mediaEstrelas: c.mediaEstrelas,

        autor: c.autor,

        favoritado: c.favoritado
      })
    );
    setDadosFormatadosEmprestimo(objRetorno);
  }

  function clickPaginacao(event, value) {
    carregarDados(value);
  }

  function openModalVisualizarLivro(livro) {
    setModalVisualizarLivro(true);
    setObjLivro(livro);
  }

  const acoes = [
    {
      texto: "Visualizar livro",
      icon: iconOlhoAberto,
      func: openModalVisualizarLivro,
    },
  ];

  return (
    <div className="container_tabelaEmprestimoAluno">
      <ToastContainer />
      <ModalInfoLivro
        abrirModal={modalVisualizarLivro}
        fecharModal={() => setModalVisualizarLivro(false)}
        nome={objLivro?.titulo}
        sinopse={objLivro?.sinopse}
        data={objLivro?.anoPublicacao}
        genero={objLivro?.genero}
        livrosDisponiveis={objLivro?.quantidadeLivros}
        avaliacao={objLivro?.mediaEstrelas}
        quantidadeAvaliacoes={objLivro?.quantidadeAvaliacoes}
        autor={objLivro?.autor}
        favorito={objLivro?.favoritado}
        idLivro={objLivro?.id}
      />
      <h2>Livros emprestados</h2>
      <>
        <div className="caixa_buscar">
          <input
            id="input_emprestimo"
            value={inputFiltro}
            type="text"
            placeholder="Buscar"
            className="input_tabelaEmprestimoAluno"
            onChange={(e) => setInputFiltro(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                carregarDados();
              }
            }}
          />
          <button className="btn_pesquisar" onClick={() => carregarDados()}>
            <img src={lupa} alt="lupa" />
          </button>
        </div>

        <div className="div_tabela">
          {dadosFormatadosEmprestimo.length === 0 ? (
            <div className="msg_dadoNaoEncontrado">
              <span>Nenhum dado encontrado.</span>
            </div>
          ) : (
            <Tabela
              dados={dadosFormatadosEmprestimo}
              colunas={colunasTabelaEmprestimoAluno}
              estiloTabela={estiloTabelaEmprestimoAluno}
              qtdPaginas={totalPaginas}
              clickPaginacao={clickPaginacao}
              acoes={acoes}
              carregandoPagina={carregandoPagina}
            />
          )}
        </div>
      </>
    </div>
  );
}
